import * as Constants from "../actions/constants";

const initialState = {
  isOpen: true,
  text: null,
  breadcrumbs: [],
  items: [],
  menu: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.TOGGLE_PANEL:
      return {
        ...state,
        text: action.payload.text,
      };
    case Constants.TOGGLE_SIDEBAR:
      return {
        ...state,
        isOpen: action.payload.isOpen,
      };
    case Constants.SET_SIDEBAR_ITEMS:
      return {
        ...state,
        items: state.menu[action.payload.role] || [],
      };
    case Constants.MENU:
      return {
        ...state,
        menu: action.payload.menu,
      };
    case Constants.BREADCRUMBS:
      return {
        ...state,
        breadcrumbs: action.payload.breadcrumbs,
      };
    case Constants.LOADING:
      return {
        ...state,
        isLoading: action.payload.isLoading,
        loadingText: action.payload.loadingText,
      };
    case Constants.AUTH:
      return {
        ...state,
        auth: action.payload.auth,
      };
    case Constants.API_ERROR:
      return {
        ...state,
        apiError: action.payload.error,
      };

    default:
      return state;
  }
};

export default reducer;
